module.exports = __webpack_public_path__ + "img/tw.ecdb8344.svg";